import { FlexView } from '@cuemath/comps';
import { Image, Separator, Text } from '@cuemath/web-comps';
import React from 'react';
import { getFormattedDate } from 'utils';
import styled from 'styled-components';
import COLORS from 'constants/colors';
import maintenance from 'img/maintenance.svg';

const Container = styled(FlexView)`
  padding: 40px;
`;

const ImageWrapper = styled(FlexView)`
  padding: 16px;
  background-color: ${COLORS.ORANGE_1};
`;

const Maintenance = ({ underMaintenance, maintenanceEndTs }) => {
  if (!underMaintenance) {
    return null;
  }

  return (
    <Container>
      <ImageWrapper alignItems="center" justifyContent="center">
        <Image width={170} height={102} url={maintenance} imgAlt="Under Maintenance" />
      </ImageWrapper>
      <Separator height={16} />
      <Text variant="h6">
        We’ll be back{' '}
        {maintenanceEndTs
          ? 'by ' + getFormattedDate(maintenanceEndTs * 1000, 'h:mm A')
          : 'soon.'}
      </Text>
      <Separator height={8} />
      <Text variant="body1Regular">
        We are under maintenance. We apologize for any inconvenience and appreciate your
        understanding.
      </Text>
    </Container>
  );
};

export default Maintenance;
